const PDF_EXTENSION = '.pdf';

const PDF_MIME_TYPES = new Set(['application/pdf', 'application/x-pdf']);

/**
 * Detects PDF uploads when MIME type is missing or non-standard (common on drag-and-drop).
 */
export const isPdfFile = (file: Pick<File, 'name' | 'type'>): boolean => {
  if (file.name.toLowerCase().endsWith(PDF_EXTENSION)) return true;
  return PDF_MIME_TYPES.has(file.type);
};
